import axios from 'src/workspace/axios';
import { setDetails } from './slice';

const revyreEntityDetailsApi = (entityId, domainType, workflowType) =>
  `/vymo/v3/workflow/${
    domainType !== 'workflow' ? domainType : workflowType
  }/${entityId}`;

export const fetchWorkflowDetails = async ({
  workflowId,
  domainType,
  workflowType,
  dispatch,
}: {
  workflowId?: string;
  workflowType?: string;
  domainType?: string;
  dispatch?: any;
}) => {
  const response = await axios.get(
    revyreEntityDetailsApi(workflowId, domainType, workflowType),
    {
      headers: {
        'x-vymo-device-type': 'web',
      },
    },
  );

  dispatch(
    setDetails({
      entityId: workflowId,
      data: response?.data,
      revyre: true,
    }),
  );
  return response;
};
